<template>
    <div class="bg">
    <headline :params="headLines"></headline>
    <div class="main">
      <div class="content">
          <div class="btn-container">
              <p v-for="(item,index) in list_search" :key="index" @click="selectIndex=item.value" :class="{on: selectIndex == item.value}">{{item.title}}</p>
          </div>

          <div class="filter-container">
              <div v-click-outside="closeCard" class="dateFilter">
                  <div @click="toggleShow" class="title-container">
                      <p class="title">{{filterList[orderbyIndex-1].title}}</p>
                      <i :class="{down: true, on: showFilter}"></i>
                  </div>
                  <div v-if="showFilter" class="select-container">
                      <p></p>
                      <ul>
                          <li v-for="(item,index) in filterList" :key="index" @click="orderbyIndex = item.value;showFilter = false" :class="{on: orderbyIndex == item.value}">
                              <p class="title">{{item.title}}</p>
                              <i class="gou"></i>
                          </li>
                      </ul>
                  </div>
              </div>
              <div class="inputFilter">
                  <input @keydown.enter="search" v-model="keywords" placeholder="请输入要查找的内容" type="text">
                  <img @click="search" src="../assets/img/index/search.png">
              </div>
          </div>

          <div class="list-container">
              <ul ref="list">
                  <li @click="newInsert()" ref="miniList" class="list" :style="{height: `${itemHeight}px`}">
                      <div class="top-container">
                          <p class="addBtn">
                              <img src="../assets/img/upload/addLarge.png" alt="">
                          </p>
                      </div>
                      <div class="bottom-container">
                          <p class="addText">创建项目，开启创作</p>
                      </div>
                  </li>
                  <li v-for="(item,index) in list" :key="index" class="list" :style="{height: `${itemHeight}px`}">
                      <div @click="newInsert(item.meisheurl)" class="top-container">
                          <div :style="'background-image:url('+item.cover+')'" class="imgBg"></div>
                      </div>
                      <div class="bottom-container">
                          <div @click="newInsert(item.meisheurl)" :title="item.title" class="title">{{item.title}}</div>
                          <p class="date">
                            <span @click="newInsert(item.meisheurl)">最近使用:{{item.raw_update_time}}</span>
                            <img @click="openEdit(index)" @mouseenter="item.imgType = false" @mouseleave="item.imgType = true" :src="item.imgType ? moreIcon : moreIconGreen" alt="">
                          </p>
                          <div v-if="item.editStatus" v-click-outside="closeEdit" class="set-container">
                              <p @click="newInsert(item.meisheurl)" class="edit1">
                                  <i class="edit"></i>
                                  <span>剪辑</span>
                              </p>
                              <p @click="copyEdit(item.idstring)" class="copy1">
                                  <i class="copy"></i>
                                  <span>复制</span>
                              </p>
                              <p @click="delEdit(item.idstring)" class="del1">
                                  <i class="del"></i>
                                  <span>删除</span>
                              </p>
                          </div>
                      </div>
                  </li>
                  <li class="fillItem" :style="{height: 0, width: `${fillWidth}px`}"></li>
              </ul>
          </div>
          <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
    <includeCluesList @refresh="refresh" ref="includeClues" />
  </div>
</template>

<script>
import headline from '@components/headline'
import { apis } from "@common/config";
import common from '@common/common'
import vClickOutside from 'v-click-outside'
import pages from "@components/pages";
import includeCluesList from "@components/includeCluesList";

export default {
    name: 'cloudEdit',
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        headline,
        pages,
        includeCluesList
    },
    data() {
        return {
            defaultImg: require("@assets/img/common/default.png"),
            moreIcon: require("@/assets/img/upload/more.png"),
            moreIconGreen: require("@/assets/img/cloudEdit/more.png"),
            imgType: true,
            headLines: {
                title: '视频剪辑项目',
                showLink: false,
                filter: false
            },
            fillWidth: 0,
            itemHeight: 163,
            list: [],
            filterList: [
                {title: "按修改时间",value: 1},
                {title: "按创建时间",value: 2}
            ],
            keywords: '',
            selectIndex: 1,
            orderbyIndex: 1,
            showFilter: false,
            page: {
                pageCount: 0,
                pageSize: 19,
                pageIndex: 1,
                total: 0
            },
            editIndex: 'null',
            list_search: {}
        }
    },
    watch: {
        selectIndex() {
            this.page.pageIndex = 1;
            this.orderbyIndex = 1;
            this.keywords = '';
            this.getList();
        }
    },
    methods: {
        copyEdit(id) {
            const info = {
                idstring: id
            }

            common.myFetch(apis.copyvideoInsert, {method: 'post', data: info})
            .then((data) => {
                if (!data) return
                this.page.pageIndex = 1;
                this.orderbyIndex = 1;
                this.keywords = '';
                this.getList();
            })
        },
        delEdit(id) {
            const info = {
                idstring: id
            }

            common.myFetch(apis.deletevideoInsert, {method: 'post', data: info})
            .then((data) => {
                if (!data) return
                this.page.pageIndex = 1;
                this.orderbyIndex = 1;
                this.keywords = '';
                this.getList();
            })
        },
        refresh() {
            this.page.pageIndex = 1;
            this.orderbyIndex = 1;
            this.keywords = '';
            this.getList();
        },
        search() {
            this.page.pageIndex = 1;
            this.getList();
        },
        openEdit(index) {
            // console.log(this.editIndex,index)
            // return false;
            // console.log(this.editIndex,index)
            if(this.editIndex != 'null'){
                this.list[this.editIndex].editStatus = false;
            }
            this.list[index].editStatus = true;
            this.editIndex = index
        },
        closeEdit() {
            if(this.editIndex != 'null') {
                this.list[this.editIndex].editStatus = false;
            }
        },
        toggleShow() {
            this.showFilter = !this.showFilter
        },
        closeCard() {
            this.showFilter = false
        },
        setHeight() {

        },
        calcFillWidth() {
            // 计算填充元素宽度
            const list = this.$refs.list;
            if (!list || !list.getBoundingClientRect()) return;
            const listWidth = list.getBoundingClientRect().width;
            let fillWidth = 0;
            const itemWidth = 194; // item dom宽度
            const itemGap = 30; //item 边距
            const listGap = 0; // list左右边距
            const countsPerPage = this.list.length+1 || 20; //每页的item数量
            const containerWidth = listWidth - listGap; //容器实际宽度（dom宽度 - 左右padding）
            const countsPerRow = parseInt(containerWidth / (itemWidth + itemGap)); //每行item数量
            const countsLastLine = countsPerPage % countsPerRow || countsPerRow; //最后一行的item数量
            const itemRatio = 163 / 194;
            const itemWidthNow = (listWidth - listGap) / countsPerRow - itemGap;
            const itemHeightNow = itemWidthNow * itemRatio;

            // console.log(itemWidthNow)

            fillWidth =
                countsPerRow === countsLastLine
                ? 0
                : (countsPerRow - countsLastLine) * (itemWidthNow + itemGap);

            this.fillWidth = fillWidth;

            // console.log(listWidth,countsPerRow,listWidth/countsPerRow,((itemWidthNow)*9/16))

            this.$nextTick(() => {
                let dom = document.querySelectorAll('.list-container .list')[0]
                this.itemHeight = (dom.getBoundingClientRect().width*9/16)+55;
            })
            
        },
        addCalcEvent() {
            // 监听list dom宽度变化
            window.addEventListener("resize", () => {
                this.calcFillWidth();
            });
        },
        getList() {
            const info = {
                type: this.selectIndex,
                orderby: this.orderbyIndex,
                keywords: this.keywords,
                page: this.page.pageIndex,
                pagesize: this.page.pageSize
            }

            common.myFetch(apis.editvideoList, {method: 'post', data: info})
            .then((data) => {
                if (!data) return
                data.list.forEach(element => {
                    element.editStatus = false;
                    element.imgType = true;
                    if(element.cover == ''){
                        element.cover = this.defaultImg
                    }

                    if(element.title == ''){
                        element.title = '未命名项目'
                    }
                });
                this.editIndex = 'null'
                this.list = data.list;
                this.list_search = data.params.list_search;
                this.filterList = data.params.select_search.options;
                this.page.pageCount = Number(data.page.page_count);
                this.page.total = Number(data.page.row_count);
                this.$nextTick(() => {
                    this.calcFillWidth();
                })
            })
        },
        newInsert(meisheurl) {
            let info = {
                title: '',
                id: ''
            }
            // if(id&&title) {
            //     info.title = title;
            //     info.id = id;
            // }
            if(this.selectIndex == 1){
                // console.log(meisheurl)
                // return false
                if(meisheurl){
                    window.location.href = meisheurl
                }else{
                    this.$cloudEditConfirm(info).then((res) => {
                        if(res != 999){
                            this.page.pageIndex = 1;
                            this.orderbyIndex = 1;
                            this.keywords = '';
                            this.getList();
                            let unid = common.getUnid();
                            let uid = common.getUid();
                            window.location.href = res.meisheurl
                            console.log(res)
                        }
                    })
                }
                
            }else{
                if(meisheurl){
                    // info.idstring = idstring;
                    // info.url = url;
                    // this.$cloudEditConfirmStream(info).then(() => {
                    //     this.page.pageIndex = 1;
                    //     this.orderbyIndex = 1;
                    //     this.keywords = '';
                    //     this.getList();
                    // })
                    window.location.href = meisheurl
                }else{
                    this.$refs.includeClues.open('正在收录');
                }
            }
            
        }
    },
    mounted() {
        this.defaultImg = this.$_syscfg.default_img
        if(this.$route.params.type == 'live') {
            this.selectIndex = 2
        }else{
            this.selectIndex = 1
        }
        this.addCalcEvent();
        this.getList();
        // this.$refs.includeClues.open();
    }
}
</script>

<style lang="less" src='@assets/css/cloudEdit.less' scoped></style>